const getStandingCommitteesOnly = (committees) => {
    return committees.filter((committee) => committee.sessionId);
};

export default getStandingCommitteesOnly;